<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (station) {
    <div class="form-group mb-2 mt-0">
        <h6 class="node-name m-0 font-size-14">{{ modifyInfoCommand.getName() }}</h6>
    </div>
    @if (isEditingEnabled) {
        <div class="mb-2">
            <div class="align-items-center mt-2">
                <sui-select-enum-component (valueChanged)="setIsPoP($event)" [config]="isPoPControl"></sui-select-enum-component>
            </div>
            @if (layersControl) {
                <div class="align-items-center mt-2">
                    <sui-select-component (valueChanged)="setLayer($event)" [config]="layersControl"></sui-select-component>
                </div>
            }
            @if (!projectStateService.isAreaPlannerProject()) {
                <div class="d-flex align-items-center mt-2 justify-content-between">
                    <span class="text-nowrap mb-0 p-0 font-size-12">{{ 'project.location.blockedByPole' | translate }}: </span>
                    <winde-sui-project-editable-select-component
                            (valueChanged)="setBlockedByPoleAngle($event)"
                            [config]="blockedByPoleControl"
                            class="control-with-label-width"
                    ></winde-sui-project-editable-select-component>
                </div>
                @if (mhTypeControl.value === mhTypeEnum.BU_MUST) {
                    <div class="d-flex align-items-center mt-2 mb-2 justify-content-between">
                        <span class="text-nowrap mb-0 p-0 font-size-12">{{ 'project.location.deviceAzimuth' | translate }}: </span>
                        <winde-sui-project-editable-select-component
                                (valueChanged)="setBuDeviceAzimuth($event)"
                                [config]="deviceAzimuthControl"
                                class="control-with-label-width"
                        ></winde-sui-project-editable-select-component>
                    </div>
                }
                @if (projectHasBuProducts) {
                    <div class="d-flex align-items-center mt-2 justify-content-between">
                        <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.mhType' | translate }}: </span>
                        <sui-select-enum-component
                                (valueChanged)="setMhType($event)"
                                [config]="mhTypeControl"
                                class="control-with-label-width"
                        ></sui-select-enum-component>
                    </div>
                }
                @if (mhTypeControl.value === mhTypeEnum.BU_MUST) {
                    <div class="d-flex align-items-center mt-2 justify-content-between">
                        <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.mhTgRadio' | translate }}: </span>
                        <sui-select-component
                                (valueChanged)="setPredefinedBuProductId($event)"
                                [config]="mhTgProductControl"
                                class="control-with-label-width"
                        ></sui-select-component>
                    </div>
                }
                @if (projectHasBuProducts) {
                    <div class="d-flex align-items-center mt-2 justify-content-between">
                        <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.polarity' | translate }}:</span>
                        <sui-select-enum-component
                                (valueChanged)="setSectorPolarity($event)"
                                [config]="polarityControl"
                                [readonly]="mhTypeControl.value !== mhTypeEnum.BU_MUST"
                                class="control-with-label-width"
                        ></sui-select-enum-component>
                    </div>
                }
            }
        </div>
        @if (!historyService.projectUserSessionService.isShowSectors &&
        !historyService.projectUserSessionService.isShowAllSectors &&
        unitSectorsCount > 0) {
            <div>
                <button (click)="showSectors()" class="btn btn-link btn-sm font-size-12" id="showNodeSector">
                    {{ isShowSectors ? 'Hide' : 'Show' }} sectors (<span class="sectors-counter">{{ unitSectorsCount }}</span
                >)
                </button>
            </div>
        }
        @if (historyService.isEditModeEnabled && historyService.selectedStepNumber === stepGroupEnum.LOCATIONS_AND_LOSES) {
            <div>
                <button
                        (click)="createLos()"
                        [disabled]="!allowLosStations.length || !station.isEnabled()"
                        class="btn btn-link btn-sm font-size-12"
                        id="createLos"
                >
                    Create LOS to neighbors (<span class="los-counter">{{ allowLosStations.length }}</span
                >)
                </button>
            </div>
        }
        @if (historyService.isEditModeEnabled && historyService.selectedStepNumber === stepGroupEnum.LOCATIONS_AND_LOSES) {
            <div>
                <button
                        (click)="verifyLos()"
                        [disabled]="!losToVerify.length || !station.isEnabled()"
                        class="btn btn-link btn-sm font-size-12"
                        id="validateLos"
                >
                    Validate LOS to neighbors (<span class="los-counter">{{ losToVerify.length }}</span
                >)
                </button>
            </div>
        }
        <div>
            <button (click)="showConfig()" class="btn btn-link btn-sm font-size-12" id="nodeProperties">
                {{ 'project.location.properties' | translate }}
            </button>
        </div>
        @if (isEditingEnabled) {
            <div>
                <button (click)="toggleDisable()" class="btn btn-link btn-sm font-size-12" id="disableNode">
                    @if (station.isEnabled()) {
                        <span>Disable location</span>
                    }
                    @if (!station.isEnabled()) {
                        <span>Enable location</span>
                    }
                </button>
            </div>
        }
        @if (isEditingEnabled) {
            <div>
                <button (click)="delUnit()" class="btn btn-link btn-sm font-size-12" id="deleteNode">Delete location</button>
            </div>
        }
    } @else {
        <div class="mb-2">
            <div class="align-items-center mt-2 font-size-12">{{ '' + isPoPControl.value | translateEnum: 'IsPopEnum' }}</div>
        </div>
        @if (layersControl) {
            <div class="align-items-center mt-2 font-size-12">
                {{ layersControl.value.value }}
            </div>
        }
        <div class="d-flex align-items-center mt-2 justify-content-between">
            <span class="text-nowrap mb-0 p-0 font-size-12">{{ 'project.location.blockedByPole' | translate }}: </span>
            <span class="mb-0 font-size-12">
                {{ getBlockedByPoleTextValue() }}
            </span>
        </div>
        @if (mhTypeControl.value === mhTypeEnum.BU_MUST) {
            <div class="d-flex align-items-center mt-2 mb-2 justify-content-between">
                <span class="text-nowrap mb-0 p-0 font-size-12">{{ 'project.location.deviceAzimuth' | translate }}: </span>
                <span class="mb-0 font-size-12">
                    {{ getDeviceAzimuthTextValue() }}
                </span>
            </div>
        }
        @if (projectHasBuProducts) {
            <div class="d-flex align-items-center mt-2 justify-content-between">
                <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.mhType' | translate }}: </span>
                <span class="mb-0 font-size-12">
                    {{ mhTypeControl.value | translateEnum: 'NodeTypeEnum' }}
                </span>
            </div>
        }
        @if (mhTypeControl.value === mhTypeEnum.BU_MUST) {
            <div class="d-flex align-items-center mt-2 justify-content-between">
                <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.mhTgRadio' | translate }}: </span>
                <span class="mb-0 font-size-12">
                    {{ mhTgProductControl.value.name }}
                </span>
            </div>
        }
        @if (projectHasBuProducts && mhTypeControl.value !== mhTypeEnum.BU_MUST) {
            <div class="d-flex align-items-center mt-2 justify-content-between">
                <span class="col mb-0 p-0 text-nowrap font-size-12">{{ 'project.location.polarity' | translate }}: </span>
                <span class="mb-0 font-size-12">
                    {{ polarityControl.value | translateEnum: 'SectorPolarityEnum' }}
                </span>
            </div>
        }
        <div class="mt-2">
            <button (click)="showConfig()" class="btn btn-link btn-sm font-size-12">
                {{ 'project.location.properties' | translate }}
            </button>
        </div>
    }
}
